import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchAdminModerationJobs,
  updateAdminModerationJob,
  type AdminModerationJob,
  type ModerationStatus,
} from '../api/adminModeration';

export function useAdminModerationJobs(status?: ModerationStatus) {
  return useQuery<AdminModerationJob[]>({
    queryKey: ['admin-moderation', status ?? 'all'],
    queryFn: () => fetchAdminModerationJobs(status),
  });
}

export function useModerationAction(status?: ModerationStatus) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, nextStatus, note }: { id: number | string; nextStatus: ModerationStatus; note?: string }) =>
      updateAdminModerationJob(id, nextStatus, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-moderation', status ?? 'all'] });
    },
  });
}
